import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ spacing }) => ({
  title: {
    background: "transparent",
    marginBottom: spacing(3),
    padding: 0,
  },
}));

export default useStyles;
